var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('SkipLinks'), _vm._v(" "), _c('MainHeader', {
    attrs: {
      "hash-first-cat": _vm.hashFirstCat
    }
  }), _vm._v(" "), _vm.displayNotification ? _c('notification', {
    attrs: {
      "message": _vm.notificationMessage,
      "type": _vm.notificationType
    }
  }) : _vm._e(), _vm._v(" "), _vm.notification.message ? _c('NotificationBanner', {
    attrs: {
      "message": _vm.notification.message,
      "type": _vm.notification.type
    }
  }) : _vm._e(), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-content"
    }
  }, [_vm.ready ? _c('nuxt') : _vm._e()], 1), _vm._v(" "), _c('MdmBackToTop'), _vm._v(" "), _c('TheFooter', {
    attrs: {
      "locale": _vm.locale
    }
  }), _vm._v(" "), _c('client-only', [_c(_vm.mdmLayer, {
    tag: "component"
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };